import * as swcHelpers from '@swc/helpers';
import { getLocalizedString } from '@grandvisionhq/utils';
import { getLineItemProduct } from './utils/get-line-item-product.js';
import { mapSubscriptionProperties } from './utils/map-subscription-properties.js';
import { getProductUrl } from '../../../utils/get-line-item-product-url.js';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';

const mapProductType = (serverType)=>{
    switch(serverType.toLowerCase()){
        case 'frames':
            return 'frames';
        case 'sunglasses':
            return 'sunglasses';
        case 'solutions':
            return 'solutions';
        case 'ready-readers':
            return 'ready-readers';
        case 'accessories':
            return 'accessories';
        default:
            return 'sunglasses';
    }
};
const toBaseLineItem = (serverLineItem, settings, intl)=>{
    const product = getLineItemProduct(serverLineItem);
    return swcHelpers.objectSpread({
        id: serverLineItem.id,
        productUrl: !settings.readOnly ? getProductUrl(settings.productLinkFormatter, serverLineItem, getLocalizedString(product.masterData.current.slug, intl.locale), intl.locale) : undefined,
        sku: serverLineItem.sku,
        lineItemId: serverLineItem.id,
        productType: mapProductType(product.productType),
        quantity: `${intl.getLabel('cart.item.quantity')}: ${serverLineItem.quantity}`,
        subtitle: serverLineItem.__typename !== 'LineItemBundle' ? `${getAttribute(serverLineItem.legacyProduct.masterData.current.variant, 'brandModelCode')}` : undefined,
        price: serverLineItem.price.total.gross,
        originalPrice: serverLineItem.price.total.subtotal,
        discountPrice: serverLineItem.price.total.discount.amount || undefined,
        relativeDiscount: Number((serverLineItem.price.total.discount.percentage * 100).toFixed(2)) || 0
    }, mapSubscriptionProperties(serverLineItem));
};

export { toBaseLineItem };
//# sourceMappingURL=base-line-item.js.map
